import React from 'react';
import dayjs from 'dayjs';

export const TimeCell = (props: { value?: string | number; format?: string }) => {
  const { value, format = 'DD/MM/YYYY HH:mm:ss' } = props;
  if (!value) {
    return <span>N/A</span>;
  }

  return <span>{dayjs(Number(value)).format(format)}</span>;
};
